// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"1ec20aca","1608":"1ec20aca","7661":"1ec20aca","7970":"1c08b445","9241":"1ec20aca"}[chunkId] + ".chunk.css";
};